import React, { useEffect, useState } from "react";
import { withNamespaces } from "react-i18next";
import {
  Row,
  Col,
  Card,
  CardBody,
  Container,
} from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumb from "../../components/Common/Breadcrumb";
import COGSItemDebug from "./COGSItemDebug";
import COGSProductDebug from "./COGSProductDebug";
import moment from "moment";
const COGSDebug = (props) => {

  const [monthYear, setMonthYear] = useState();
  const [currentMonthYear, setCurrentMonthYear] = useState();
  const [cogsType, setCogsType] = useState('');

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }


  useEffect(() => {
    const currentDay = new Date();
        const previousMonth = moment(currentDay).subtract(1, 'months').format('YYYY-MM');
    setMonthYear(formatDate(currentDay).slice(0, 7));
    // setMonthYear(previousMonth);
    setCurrentMonthYear(formatDate(currentDay).slice(0, 7));
    // loadAllBranches()
    // loadOrders();
  }, []);


  const [isLoading, setIsLoading] = useState(false);

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb
            alternateTitle={props.t("Cost Of Goods Sold Report Items")}
            title={props.t("COGS Debug")}
            breadcrumbItem={props.t("Cost Of Goods Sold Report Items")}
          />
          <Row>
            <Col lg={12}>
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={4}>
                      <input
                        type="month"
                        name="monthYear"
                        label={props.t("Month-Year")}
                        value={monthYear}
                        disabled={isLoading}
                        onChange={(e, v) => {
                          setMonthYear(e.target.value);
                        }}
                        max={currentMonthYear}
                        className="is-touched is-pristine av-valid form-control"
                      />
                    </Col>
                    <Col lg={4} md={4} sm={4}>
          <div className="d-flex align-items-center ml-3 mt-2">
            <div className="form-check mr-5 align-items-center">
              <input
                className="form-check-input"
                type="radio"
                name="cogsType"
                id="cogsItem"
                value="item"
                disabled={isLoading}
                checked={cogsType === 'item'}
                onChange={(e) => setCogsType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="cogsItem">
                {props.t("COGS Item")}
              </label>
            </div>
            <div className="form-check align-items-center">
              <input
                className="form-check-input"
                type="radio"
                name="cogsType"
                id="cogsProduct"
                value="product"
                disabled={isLoading}
                checked={cogsType === 'product'}
                onChange={(e) => setCogsType(e.target.value)}
              />
              <label className="form-check-label" htmlFor="cogsProduct">
                {props.t("COGS Product")}
              </label>
            </div>
          </div>
        </Col>
                  </Row>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {cogsType === 'item' && (
 <COGSItemDebug  monthYear={monthYear} onLoadingChange={(loading) => setIsLoading(loading)}/>
)}

{cogsType === 'product' && (
  <COGSProductDebug monthYear={monthYear} onLoadingChange={(loading) => setIsLoading(loading)}/>
)}
        </Container>
      </div>
    </React.Fragment>
  );
};
const mapStatetoProps = (state) => {};
export default withRouter(
  connect(mapStatetoProps, {})(withNamespaces()(COGSDebug))
);
